export default {
  navigation: {
    about: 'About',
    work: 'Work'
  },
  backToProjects: 'Back to projects',
  slider: [
    'https://mdooley.medioze.com/wp-content/uploads/2025/04/boreale.jpg',
    'https://mdooley.medioze.com/wp-content/uploads/2025/04/complement.jpg',
    'https://mdooley.medioze.com/wp-content/uploads/2025/04/expression.jpg',
    'https://mdooley.medioze.com/wp-content/uploads/2025/04/granite-club.jpg',
    'https://mdooley.medioze.com/wp-content/uploads/2025/04/iceberg-scaled.jpg'
  ],
  intro: {
    title:
      'La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace.',
    text:
      "<p>Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n<p>Dans sa version acoustique, chaque tableau est doublé d'une laine acoustique de 1 1/2'' ultra performante qui offre un indice NRC de 0,85, afin de réduire les nuisances sonores et faire de votre environnement un endroit à la fois paisible et ludique. Vous n'avez pas besoin de fonction acoustique accrue? Optez pour la version régulière tout simplement!</p>\n",
    image: 'https://mdooley.medioze.com/wp-content/uploads/2025/04/complement.jpg'
  },
  projects: [
    {
      title: 'Boréale',
      subtitle: 'Composition de 5 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/boreale-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Cafeteria',
      subtitle: 'Composition de 4 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/cafeteria.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Complement',
      subtitle: 'Composition de 2 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/complement-2.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Expression',
      subtitle: 'Composition de 2 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/expression-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Granite Club',
      subtitle: 'Composition de 5 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/granite-club-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Iceberg',
      subtitle: 'Composition de 12 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/iceberg-1-scaled.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Swing',
      subtitle: 'Composition de 3 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/swing.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    },
    {
      title: 'Territoire',
      subtitle: 'Composition de 5 tableaux',
      description:
        "<p>La collection de tableaux textiles et de murales a tout pour épater la galerie. Iconiques et vibrants, ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison. Chaque forme du dessin est taillée, cousue et assemblée à la main dans notre atelier de Québec et signée par l'artiste.</p>\n",
      images: [
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-1.jpg',
        'https://mdooley.medioze.com/wp-content/uploads/2025/04/territoire-2.jpg'
      ]
    }
  ],
  projectCta: {
    title: 'Vous êtes intéressé par ce produits?',
    text:
      '<p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime necessitatibus eius rem earum repellat dolorum distinctio non ipsam nostrum. Natus nihil id repellendus, officia varius.</p>\n',
    label: 'Voir les options'
  },
  cta: {
    title: 'Art mural textile acoustique',
    text:
      '<p>Ces tableaux ont été pensés pour embellir votre espace de bureau, salle de conférence, espace commercial, ou différentes pièces de votre maison.</p>\n',
    label: 'Voir les produits'
  },
  about: {
    title:
      'Marie Dooley Maison a été fondée par Marie elle-même en 2015, après avoir évolué comme designer de mode sous la griffe Marie Dooley Signature pendant plus de 25 ans.',
    text:
      "<p>En tant qu'amoureuse des textiles, elle a décidé de mettre son talent au service de la décoration intérieure, quittant le monde de la mode. Toujours à la recherche de tissus de haute qualité et de designs exclusifs, Marie crée pour vous une ligne de coussins et de poufs et tout récemment de tableaux textiles, entièrement fabriqués par l'équipe de Marie à Québec.</p>\n",
    image: 'https://mdooley.medioze.com/wp-content/uploads/2025/02/portrait-4.jpg'
  },
  contact: {
    title: 'Contact',
    text: '',
    email: '',
    phone: '',
    address: '',
    mapLink: null,
    image: ''
  },
  newsletter: {
    title: 'Newsletter',
    complete: 'Thank you for subscribing!',
    error: `An error occurred, please try again later.`,
    text: `Stay in touch, subscribe to our newsletter!`,
    label: `Subscribe`,
    invalid: `Invalid email address`
  },
  menu: [],
  menuLabels: {
    home: 'Home',
    about: 'About',
    work: 'Projects',
    artist: 'Marie Dooley',
    contact: 'Contact'
  }
}
